import { useReveal } from "@/hooks/useReveal";

// ── Class-builder helpers (kept tiny; reduce SectionHeading complexity) ─────
const labelCls = (gold) =>
  `text-[12px] font-bold tracking-[.22em] mb-3 ${gold ? "text-[#C8973C]" : "text-[#E8721C]"}`;

const headingCls = ({ gold, light, center }) =>
  [
    "font-display text-[42px] md:text-[58px] leading-[1] heading-bar",
    gold && "heading-bar-gold",
    light ? "text-white" : "text-[#0A1628]",
    center && "mx-auto",
  ].filter(Boolean).join(" ");

const subtitleCls = ({ light, center }) =>
  [
    "mt-5 text-[17px] max-w-3xl",
    light ? "text-[#8A96A3]" : "text-[#1E2D40]/80",
    center && "mx-auto",
  ].filter(Boolean).join(" ");

const wrapperCls = ({ seen, center }) =>
  [
    "reveal-left",
    seen && "in",
    "mb-10",
    center && "text-center mx-auto",
  ].filter(Boolean).join(" ");

// ── Components ──────────────────────────────────────────────────────────────
export const SectionHeading = ({
  label, title, subtitle,
  light = false, gold = false, center = false,
}) => {
  const [ref, seen] = useReveal();
  return (
    <div ref={ref} className={wrapperCls({ seen, center })}>
      {label && <div className={labelCls(gold)}>{label}</div>}
      <h2 className={headingCls({ gold, light, center })}>{title}</h2>
      {subtitle && <p className={subtitleCls({ light, center })}>{subtitle}</p>}
    </div>
  );
};

export const Reveal = ({ children, delay = 0, className = "" }) => {
  const [ref, seen] = useReveal();
  return (
    <div
      ref={ref}
      className={`reveal ${seen ? "in" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

const hideOnError = (e) => { e.currentTarget.style.display = "none"; };

export const PageHero = ({ label, title, subtitle, gold = false, image }) => (
  <section className="relative bg-[#0A1628] text-white diagonal-bottom corner-accent blueprint-grid overflow-hidden" data-testid="page-hero">
    {image && (
      <div className="absolute inset-0 opacity-25">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover object-center"
          loading="lazy"
          onError={hideOnError}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1628] via-[#0A1628]/85 to-transparent" />
      </div>
    )}
    <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10 pt-20 pb-32">
      {label && (
        <div className={`text-[12px] font-bold tracking-[.22em] mb-4 ${gold ? "text-[#C8973C]" : "text-[#E8721C]"}`}>{label}</div>
      )}
      <h1 className={`font-display text-[44px] md:text-[72px] leading-[0.95] max-w-5xl heading-bar ${gold ? "heading-bar-gold" : ""}`}>{title}</h1>
      {subtitle && <p className="mt-6 text-[18px] md:text-[20px] text-[#8A96A3] max-w-3xl">{subtitle}</p>}
    </div>
  </section>
);
